<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <div v-if="!loading" class="mb-3">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'wac' }"
            href="#"
            @click.prevent="setActiveTab('wac')"
          >
            <span class="text-danger font-weight-bold">
              WAC ({{ ordersWAC.length }})
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'duplicates' }"
            href="#"
            @click.prevent="setActiveTab('duplicates')"
          >
            <span class="text-danger font-weight-bold">
              To duplicate / À dupliquer ({{ ordersDuplicates.length }})
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'review' }"
            href="#"
            @click.prevent="setActiveTab('review')"
          >
            <span class="text-warning font-weight-bold">
              À revoir avant duplication ({{ ordersToReview.length }})
            </span>
          </a>
        </li>
      </ul>
      <p v-if="activeTab !== 'wac'" class="small text-muted mt-2 mb-0">
        Périmètre : available &lt; {{ AVAILABLE_MAX }}, ratio ∈ [{{ RATIO_MIN }} ; {{ RATIO_MID }}] ou &gt; {{ RATIO_RECYCLED }}.
        Éligibilité À dupliquer : client actif (status {{ ACTIVE_CLIENT_STATUS }}), ≥{{ MIN_MEETINGS }} RDV,
        ≥{{ MIN_CONTACTED }} contactés, lancé ≥{{ MIN_DAYS_SINCE_LAUNCH }} j, non déficitaire, sourcing ≠ Apollo.
      </p>
    </div>

    <!-- Table Contact  -->
    <div class="mx-0 px-0 table-responsive">
      <Table
        v-if="!loading && currentOrders.length > 0"
        class="mx-0"
        :key="tableKey + '-' + activeTab"
        :headers="tableHeaders"
        :cols="tableCols"
        :data="currentOrders"
        :checkbox="false"
        :notselect="true"
        :model="model"
        @openTarget="openTarget"
        @openClient="openClient"
      ></Table>

      <Modal name="target" :close="true">
        <div class="row">
          <div class="col-12">
            <TargetCampaigns
              v-if="target_id"
              :target_id="target_id"
              :selected="selected"
              countselected="countselected"
            ></TargetCampaigns>
          </div>
        </div>
      </Modal>
    </div>
  </section>
</template>
<script>
import { targetsService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import TargetCampaigns from "@/components/Campaigns/TargetCampaigns.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  components: {
    Table,
    TargetCampaigns,
    LoadingSpinner,
  },
  computed: {
    ordersWAC() {
      return this.orders;
    },
    perimeterOrders() {
      return this.orders.filter((o) => this.isInPerimeter(o));
    },
    ordersDuplicates() {
      return this.perimeterOrders
        .filter((o) => this.getBlockageReasons(o).length === 0)
        .slice()
        .sort((a, b) => this.sortByMeetingsThenRate(a, b));
    },
    ordersToReview() {
      return this.perimeterOrders.filter(
        (o) => this.getBlockageReasons(o).length > 0
      );
    },
    currentOrders() {
      if (this.activeTab === "duplicates") return this.ordersDuplicates;
      if (this.activeTab === "review") return this.ordersToReview;
      return this.ordersWAC;
    },
    tableHeaders() {
      const headers = [...this.baseHeaders];
      if (this.activeTab === "duplicates" || this.activeTab === "review") {
        headers.splice(3, 0, {
          label: this.activeTab === "duplicates" ? "Motif" : "Blocage",
          class: "overflowhide",
          percentage: "12%",
        });
      }
      return headers;
    },
    tableCols() {
      const cols = [...this.baseCols];
      if (this.activeTab === "duplicates") {
        cols.splice(3, 0, [
          {
            value: "duplicate_motif",
            badges: [
              {
                badge_if: "duplicate_motif",
                badge_value: "Base recyclée",
                badge_class: "badge badge-info text-white",
                badge_label: "Base recyclée",
              },
              {
                badge_if: "duplicate_motif",
                badge_value: "Séquence jouée",
                badge_class: "badge badge-secondary text-white",
                badge_label: "Séquence jouée",
              },
            ],
          },
        ]);
      } else if (this.activeTab === "review") {
        cols.splice(3, 0, [
          {
            value: "blocage_reasons",
          },
        ]);
      }
      return cols;
    },
  },
  data() {
    return {
      AVAILABLE_MAX: 100,
      RATIO_MIN: 2.8,
      RATIO_MID: 3.5,
      RATIO_RECYCLED: 5,
      ACTIVE_CLIENT_STATUS: 4,
      MIN_DAYS_SINCE_LAUNCH: 30,
      MIN_CONTACTED: 500,
      MIN_MEETINGS: 1,
      loading: true,
      tableKey: 0,
      target_id: false,
      activeTab: 'wac',
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      orders: [],
      baseHeaders: [
        {
          label: "Time",
          percentage: "3.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.label.creationdate"),
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.token.order_name"),
           percentage: "15%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.column.duplicate_reason"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
        },

        {
          label: this.$t("lang.column.launch_date"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.prospecting_days"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
        },
        {
          label: this.$t("lang.column.client"),
         
          percentage: "15%",
        },
        {
          label: "3D AVG First Contact",
          class: "overflowhide",
        },
        {
          label: "Available Contacts",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Ratio Mails/Contacts",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: this.$t("lang.label.prospectingemails"),
          percentage: "20.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
            {
          label: this.$t("lang.label.statistics"),
          class: "overflowhide",
          permission: "adminClients",
        },
            {
          label: 'Profitability',
          percentage: "12.5%",
          class: "text-danger",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Cashable Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Operating Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Global Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
      ],
      baseCols: [
        [
          {
            value: "task_open_hours",
            type: "time",
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
          },
        ],
        [
          {
            value: "duplicate_reason",
          },
        ],
        [
          {
            value_label: "target_status_id",
            class: "text-success",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: "Running",
              },
              {
                badge_if: "user_error",
                badge_value: "1",
                badge_class: "badge badge-danger text-white",
                badge_label: "User error",
              },
            ],
          },
        ],
        [
          {
            value: "launch_date",
          },
        ],
            [
          {
            value: "preparation_days",
          },
        ],
        [
          {
            value_label: "client",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "avg_sent_3day",
          },
        ],
        [
          {
            value: "available_contacts",
          },
        ],
        [
          {
            value: "ratio_display",
          },
        ],
        [
          {
            value: "prospectors_active",
          },
        ],
           [
          {
            value: "target_id",
            type: "statsBadge",
          },
        ],
           [
          {
            value: "profitability",
          },
        ],
           [
          {
            value: "cashable_margin",
          },
        ],
           [
          {
            value: "operating_margin",
          },
        ],
           [
          {
            value: "global_margin",
          },
        ],
        
      ],
    };
  },

  mounted() {
    this.init();
  },
  props: {
    oliver_sale_id: {
      type: String,
      required: "0",
    },
  },

  watch: {
    oliver_sale_id(newVal, oldVal) {
      if (newVal != oldVal) {
        this.init();
      }
    },
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
      this.model.currentPage = 1;
    },
    hasField(order, field) {
      return order[field] !== undefined && order[field] !== null;
    },
    daysSinceLaunch(order) {
      const raw = order.launch_date || order.running_date;
      if (!raw) return null;
      const launch = new Date(raw);
      if (Number.isNaN(launch.getTime())) return null;
      const ms = Date.now() - launch.getTime();
      return Math.floor(ms / (1000 * 60 * 60 * 24));
    },
    isInPerimeter(order) {
      const avail = Number(order.available_contacts) || 0;
      const ratio = Number(order.ratio) || 0;
      const ratioMatch =
        (ratio >= this.RATIO_MIN && ratio <= this.RATIO_MID) ||
        ratio > this.RATIO_RECYCLED;
      return avail < this.AVAILABLE_MAX && ratioMatch;
    },
    getBlockageReasons(order) {
      const reasons = [];

      if (this.hasField(order, "client_status_id")) {
        if (Number(order.client_status_id) !== this.ACTIVE_CLIENT_STATUS) {
          reasons.push("Client non actif");
        }
      }

      if (this.hasField(order, "total_meetings")) {
        if (Number(order.total_meetings) < this.MIN_MEETINGS) {
          reasons.push("0 RDV");
        }
      }

      if (this.hasField(order, "total_contacted_contacts")) {
        if (Number(order.total_contacted_contacts) < this.MIN_CONTACTED) {
          reasons.push("< 500 contactés");
        }
      }

      if (
        this.hasField(order, "launch_date") ||
        this.hasField(order, "running_date")
      ) {
        const days = this.daysSinceLaunch(order);
        if (days !== null && days < this.MIN_DAYS_SINCE_LAUNCH) {
          reasons.push("Order trop récent");
        }
      }

      // profitability: null = not deficit (join filters profitability < 0)
      if (Object.prototype.hasOwnProperty.call(order, "profitability")) {
        if (order.profitability !== null && Number(order.profitability) < 0) {
          reasons.push("Order déficitaire");
        }
      }

      if (this.hasField(order, "contact_source")) {
        if (order.contact_source === "Apollo") {
          reasons.push("Sourcing Apollo");
        }
      }

      return reasons;
    },
    getDuplicateMotif(order) {
      const ratio = Number(order.ratio) || 0;
      if (ratio > this.RATIO_RECYCLED) return "Base recyclée";
      if (ratio >= this.RATIO_MIN && ratio <= this.RATIO_MID) {
        return "Séquence jouée";
      }
      return "";
    },
    sortByMeetingsThenRate(a, b) {
      const meetingsDiff =
        (Number(b.total_meetings) || 0) - (Number(a.total_meetings) || 0);
      if (meetingsDiff !== 0) return meetingsDiff;
      return (Number(b.meeting_rate) || 0) - (Number(a.meeting_rate) || 0);
    },
    init() {
      this.loading = true;
      this.orders = [];
      targetsService
        .getFinishedTarget(null, 25, this.oliver_sale_id)
        .then((result) => {
          this.orders = (result || []).map((o) => {
            const ratioValue = o.ratio != null ? Number(o.ratio) : 0;
            const mapped = {
              ...o,
              available_contacts: Number(o.available_contacts) || 0,
              ratio: ratioValue,
              ratio_display: ratioValue ? ratioValue.toFixed(2) : "-",
            };
            mapped.duplicate_motif = this.getDuplicateMotif(mapped);
            mapped.blocage_reasons = this.getBlockageReasons(mapped).join(" · ");
            return mapped;
          });
          this.tableKey++;
          this.loading = false;
        });
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      } else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
    openTarget(target_id) {
      //this.$modal.show("target");
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>
